export default "__VITE_ASSET__BzMVe$Ai__"